/**
 * Shared models and types for QwykPortals applications
 * Exports organized by domain: auth, common, hub, masterdata, portals, ui
 * 
 * Usage:
 *   - Direct imports: import { Shipment } from '@qwyk/models/portals'
 *   - Namespaced: import { Portals, Hub, common } from '@qwyk/models'
 */

// Export all types from each domain
export * from './lib/auth';
export * from './lib/common';
export * from './lib/hub';
export * from './lib/masterdata';
export * from './lib/portals';
export * from './lib/ui';

// Export commonly used types explicitly for convenience
// (currently covered by the domain re-exports above)
export { TransportMode } from './lib/common';

// Namespace exports for organized access
import * as auth from './lib/auth';
import * as common from './lib/common';
import * as Hub from './lib/hub';
import * as masterdata from './lib/masterdata';
import * as Portals from './lib/portals';
import * as ui from './lib/ui';

export { auth, common, Hub, masterdata, Portals, ui };
